export enum TipoPagamentoEnum {
  MENSAL = 'MENSAL',
  FLEXIVEL = 'FLEXÍVEL'
}